import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DEFAULT_KEYS } from '@weavix/models/src/person/person-matcher';
import { DropdownItem } from 'components/dropdown/dropdown.model';
import { AutoUnsubscribe, Utils } from 'weavix-shared/utils/utils';
import { ComplexConditionForm, PersonMatcherService } from './person-matcher.service';
import { Subscription } from 'rxjs';
import { isEqual } from 'lodash';
import { PersonSelect } from '@weavix/models/src/person/person-select';
import { LoadingComponent } from 'components/loading/loading.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { PeoplePreviewComponent } from 'components/people-preview/people-preview.component';
import { ComplexConditionComponent } from './complex-person-condition/complex-condition.component';
import { StandardMatcherComponent } from './standard-matcher/standard-matcher.component';
import { CommonModule } from '@angular/common';

export interface PersonMatcherHelper {
    keys: DropdownItem[];
    negate: { [key: string]: DropdownItem[] };
}

@AutoUnsubscribe()
@Component({
    selector: 'app-person-matcher',
    templateUrl: './person-matcher.component.html',
    styleUrls: ['./person-matcher.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatSlideToggleModule,
        ReactiveFormsModule,
        TranslateModule,

        LoadingComponent,
        PeoplePreviewComponent,
        StandardMatcherComponent,
        ComplexConditionComponent,
    ],
})
export class PersonMatcherComponent implements OnInit, OnDestroy {
    @Input() label = 'configuration.person-matcher.conditional-filter';
    @Input() formGroup: FormGroup;
    @Input() includes = DEFAULT_KEYS;
    @Input() self = false;
    @Input() isShowPreview = false;
    @Input() filteredPeople: PersonSelect[] = [];
    @Input() everyoneLabel?: string;
    /** Optional test-id root passed down to the condition builder. */
    @Input() testID?: string;
    @Output() changed = new EventEmitter<void>();

    conditions: ComplexConditionForm;
    helper: PersonMatcherHelper;

    loading = true;

    subscriptions: Subscription[] = [];

    constructor(
        private readonly personMatcherService: PersonMatcherService,
    ) {}

    async ngOnInit() {
        this.conditions = this.formGroup.get('conditions') as FormGroup;
        this.subscriptions = [
            this.conditions.valueChanges.subscribe(value => {
                this.changed.emit();
            }),
        ];

        try {
            await this.personMatcherService.loadValues();
        } catch (e) {
            console.error('chip loading', e);
        }
        this.personMatcherService.configureFilterDropdownOptions(this.includes, this.self);

        this.loading = false;

        // emit after loading to populate
        this.changed.emit();
        const conditionsValue = this.conditions.value;
        Utils.safeSubscribe(this, this.conditions.valueChanges).subscribe(() => {
            if (!isEqual(this.conditions.value, conditionsValue)) this.conditions.markAsDirty();
            else this.conditions.markAsPristine();
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(v => v.unsubscribe());
    }
}
